import Daun1 from "../../../assets/images/s9_daun_1.png"
import Daun2 from "../../../assets/images/s9_daun_2.png"
import ImageS9 from "../../../assets/images/s9_image.png"

const Section9 = () => {
    return (
        <div className="w-full h-screen md:pt-20 flex flex-col items-center justify-center  relative">
            <h1 className="text-3xl md:text-5xl font-bold text-custom-green absolute top-20">Meet Our Farmer</h1>
            <img src={Daun1} alt="Kebun Jitu" className='w-[200px] object-contain absolute bottom-20 md:bottom-auto left-0 z-10' loading='lazy'/>
            <img src={Daun2} alt="Kebun Jitu" className='w-[200px] object-contain absolute top-[20%] right-0 z-10' loading='lazy'/>
            <div className="w-full h-[100px] bg-black flex items-center justify-center relative md:mt-16">
                <div className="w-full h-full bg-gradient-to-b from-custom-green to-custom-green/30"/>
                    <img src={ImageS9} alt="Kebun Jitu" className='w-[250px] md:w-[350px] object-contain absolute left-[20%]' loading='lazy'/>
            </div>
        </div>
    )
}

export default Section9